import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';

import { conversionListReport, audiencePopupDetail } from 'lib/api/conversion';
import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const ConversionListStatistics = ({ location }) => {
  let initParams = {
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  // 키워드통계 - 지출금액  : sDate, eDate, intgSeq, uri, isPop
  // 통계보고서 - 일자별통계 - 일자별통계: sDate, eDate, itlTpCode, uri, isPop,

  const convertKeys = [
    'intgSeq',
    'adverId',
    'mediaScriptNo',
    'advrtsPrdtCode',
    'itlTpCode',
    'mediaId',
    'advrtsTpCode',
    'pltfomTpCode',
    'sDate',
    'eDate',
    'uri',
  ];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };

  const isPopPage = queryString.parse(location.search).isPop === '1';
  const { backPage } = queryString.parse(location.search);

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      if (isPopPage && window.location.search !== '?isPop=1') {
        window.location.replace(window.location.pathname + '?isPop=1');
      }
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    INFLOW_ROUTE: {
      makeBody: (rowObj, headsMap) => {
        const corpName = getHeadObj(headsMap, 'INFLOW_ROUTE');
        return (
          <div className="mb-corpName-text" title={rowObj['INFLOW_ROUTE']}>
            {makeRowColumn(
              rowObj['INFLOW_ROUTE'],
              corpName.type,
              corpName.format
            )}
          </div>
        );
      },
    },
    PNM: {
      makeBody: (rowObj, headsMap) => {
        const corpName = getHeadObj(headsMap, 'PNM');
        return (
          <div className="mb-corpName-text" title={rowObj['PNM']}>
            {makeRowColumn(rowObj['PNM'], corpName.type, corpName.format)}
          </div>
        );
      },
    },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={
          backPage === 'audience' ? audiencePopupDetail : conversionListReport
        }
        customized={customized}
        useTotal={false}
        useFetch={false}
      />
    </>
  );
};

export default withRouter(ConversionListStatistics);
